import React, { useState } from "react";

import useInterval from "../../../hooks/useInterval";

import SnackBar, { SnackBarProps } from "./SnackBar";

interface UseSnackBarProps extends SnackBarProps {
  time: number; // time in 1/100 seconds or null for cancelling the call
}

const useSnackBar = ({
  time,
  ...props
}: UseSnackBarProps): [() => void, JSX.Element] => {
  const [show, setShow] = useState(false);
  const [timer, setTimer] = useState<number | null>(null);

  useInterval(
    () => {
      if (timer === 1) {
        setShow(false);
      }
      setTimer((tm) => (tm !== null ? tm - 1 : tm));
    },
    show !== false ? 100 : null
  );

  const trigger = () => {
    setShow(true);
    setTimer(time);
  };

  return [trigger, <>{show && <SnackBar {...props} />}</>];
};

export default useSnackBar;
